import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./../../../css/StudentPage.scss";
import axios from 'axios';
import { IoAlertCircle, IoWarning } from "react-icons/io5";

const StudentPage = () => {
    const { id } = useParams();

    const [student, setStudent] = useState(null);
    const [violations, setViolations] = useState([]);
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    const formatTerm = (term, nextToNumber = true) => {
        const year = Math.floor(term / 100);
        const termNum = term % 100;
        let result;

        switch (termNum) {
            case 9:
                result = `Fall ${year}`;
                break;
            case 1:
                result = `Spring ${year}`;
                break;
            case 6:
                result = `Summer ${year}`;
                break;
            default:
                result = '';
        }

        if (nextToNumber) {
            return result !== '' ? ` (${result})` : '';
        } else {
            return result !== '' ? result : `${term}`
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const [studentResponse, violationsResponse, coursesResponse] = await Promise.all([
                    axios.get(`/api/students/${id}`),
                    axios.get(`/api/students/${id}/violations`),
                    axios.get(`/api/students/${id}/courses`),
                ]);

                console.log(studentResponse.data)
                setStudent(studentResponse.data.student);
                setViolations(violationsResponse.data.violations || []);
                setCourses(coursesResponse.data.courses || []);
            } catch (error) {
                console.error("Error fetching student data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    let tableCourseTerm = null;
    let tableCourseRowOddColor = true

    return (
        <div className="page-body">
            <h1>Student Info: <span className="student-name">{student?.name}</span></h1>
            <div className="content-container">
                <div className="info-wrapper">
                    <div className="box">
                        <h2>Basic Information</h2>
                        {loading ? (
                            <div>Loading student information...</div>
                        ) : (
                            <>
                                <div>
                                    <strong>Name:</strong> {student?.name}
                                </div>
                                <div>
                                    <strong>Student ID:</strong> {student?.id}
                                </div>
                                <div>
                                    <strong>Email:</strong>  {student?.email}
                                </div>
                                <div>
                                    <strong>Advisor Last Name:</strong> {student?.advisor_lname || "(Unassigned)"}
                                </div>
                                <div>
                                    <strong>Concentration:</strong> {student?.concentration || "CS"}
                                </div>

                            </>
                        )}
                    </div>

                    <div className="box">
                        <h2>Details</h2>
                        {loading ? (
                            <div>Loading details...</div>
                        ) : (
                            <>
                                <div>
                                    <strong>Admit Term:</strong> {formatTerm(student?.admit_term, false)}
                                </div>
                                <div>
                                    <strong>Current Term:</strong> {formatTerm(student?.current_term, false)}
                                </div>
                                <div>
                                    <strong>Graduation Term:</strong> {formatTerm(student?.completion_term_code, false)}
                                </div>
                                <div>
                                    <strong>Standing Message:</strong> {student?.standing_message}
                                </div>
                                <div>
                                    <strong>Overall GPA:</strong> {student?.overall_gpa ? student.overall_gpa.toFixed(2) : 0}
                                </div>
                                <div>
                                    <strong>In Major GPA:</strong> {student?.in_major_gpa ? student.in_major_gpa.toFixed(2) : 0}
                                </div>
                                <div>
                                    <strong>Overall Hours Attempted:</strong> {student?.overall_hours_attempted}
                                </div>
                                <div>
                                    <strong>Transfer Hours Earned:</strong> {student?.transfer_hours_earned}
                                </div>
                                <div>
                                    <strong>Hours to 123:</strong> {123 - student?.overall_hours_attempted} 
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className="courses-section"> {/* Backend Needed: Classes For Graduation*/}
                    <div className="box">
                        <h2>Courses Needed For Graduation</h2>
                        {loading ? (
                            <div>Loading details...</div>
                        ) : (
                            <>
                                {courses.length === 0 ? (
                                    <label>
                                        Student has met all requirements
                                    </label>
                                ) : (
                                    <div className="table-wrapper">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Course</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {student?.missing_courses ? JSON.parse(student.missing_courses).map((course, index) => {
                                                    return (
                                                        <tr
                                                            key={course.id}
                                                            className={index%2 == 0 ? 'odd-color' : 'even-color'}                                                >
                                                            <td className="nowrap">{course}</td>
                                                        </tr>
                                                    )
                                                }):<></>}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    <div className="box">
                        <h2>Courses</h2>
                        {loading ? (
                            <div>Loading courses...</div>
                        ) : (
                            <>
                                {courses.length === 0 ? (
                                    <label>
                                        No courses found for this student.
                                    </label>
                                ) : (
                                    <div className="table-wrapper">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Course</th>
                                                    <th>Term Taken</th>
                                                    <th>Credit Hours</th>
                                                    <th>Course Grade</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {courses.map((course) => {
                                                    if (tableCourseTerm === null) {
                                                        tableCourseTerm = course.term_taken
                                                    } else if (course.term_taken !== tableCourseTerm) {
                                                        tableCourseRowOddColor = !tableCourseRowOddColor
                                                        tableCourseTerm = course.term_taken
                                                    }

                                                    return (
                                                        <tr
                                                            key={course.id}
                                                            className={tableCourseRowOddColor ? 'odd-color' : 'even-color'}                                                >
                                                            <td className="nowrap">{course.subj_expanded}{course.course_number}</td>
                                                            <td className="nowrap">{formatTerm(course.term_taken, false)}</td>
                                                            <td>{course.credit_hours}</td>
                                                            <td>{course.grade}</td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
                <div className="box">
                    <h2>Violations</h2>
                        {loading ? (
                            <div>Loading violations...</div>
                        ) : (
                            <>
                            <div>
                                    {violations.length === 0 ? (
                                        <>&nbsp;None.</>
                                    ) : (
                                        <ul className="violation">
                                            {violations.map((violation) => (
                                                <li key={violation.id} className={violation.is_warning ? 'yellow-text' : 'red-text'}>
                                                    {violation.is_warning
                                                        ? <IoWarning />
                                                        : <IoAlertCircle />}
                                                    {violation.message}
                                                    {violation.associatedCourses?.length > 0 &&
                                                        <ul>
                                                            {violation.associatedCourses.map((course, i) => (
                                                                <li>{course.subj_expanded}{course.course_number}{formatTerm(course.term_taken)}</li>
                                                            ))}
                                                        </ul>
                                                    }
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </>


                        )}
                </div>

            </div>
        
        </div>
    );
};

export default StudentPage;